import React, { useContext, useEffect, useRef } from 'react'
import { Image } from '@telus/koodo-ui-kit'
import { useHistory } from 'react-router-dom'
import ConsumerActivationPaths from '@sites/consumer/activation/ConsumerActivationPaths'
import { useLocation } from 'react-router'
import Sites from '@sites/index'
import { setPageAnalytics } from '@apps/utils/Analytics'
import { getPromoNames } from '@apps/utils/common'
import { APPLICATION_STATE, ApplicationContext, setActivateAllTrigerred } from '@apps/contexts/ApplicationContext'
import { getBySlug, getById, getImgByTitle } from '@apps/utils/contentful'
import { useSelector } from 'react-redux'
import Heading1 from '@/apps/components/Typography/Heading1'
import Heading2 from '@/apps/components/Typography/Heading2'
import Body from '@/apps/components/Typography/Body'
import useTagManagerInfo from '../../../_engine/hooks/useTagManagerInfo'

const ProcessLoader = () => {

  // Select only required slices/fields to avoid subscribing to entire root state which reduces unnecessary re-renders
  const { content: { pageContent, featureFlags } = {}, userType } = useSelector((state) => state.common)
  const { selectSimType } = useSelector((state) => state.simSelectionPage)
  const { plan } = useSelector((state) => state.plansPage)
  const { multiPromotionCodeInfo } = useSelector((state) => state.payAndReviewPage)

  const consumerActivationPaths = new ConsumerActivationPaths()
  const history = useHistory()

  if (featureFlags && featureFlags[0]?.showSplashing) {
    history.push(consumerActivationPaths.Splash)
  }

  const pageRef = useRef(null)

  useEffect(() => {
    setActivateAllTrigerred(false)
    window.scrollTo(0, 0)
    if (pageRef.current) {
      const minHeight = window.innerHeight
      pageRef.current.style.minHeight = `${minHeight}px`
    }
  }, [])

  useEffect(() => {
    const unblock = history.block((location, action) => {
      if (action === 'pop' || action === 'POP') {
        return false
      }

      return () => {
        unblock()
      }
    })
  }, [history])

  const {
    [APPLICATION_STATE.CURRENT_LANGUAGE]: language,
    [APPLICATION_STATE.CURRENT_REGION]: region,
  } = useContext(ApplicationContext)

  const location = useLocation()
  const tagManagerInfo = useTagManagerInfo()

  const pushTagManagerToDataLayer = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(
      setPageAnalytics(location, 'form', region, language, {
        ...tagManagerInfo,
        promoCodeDescription: getPromoNames([plan?.promo, ...multiPromotionCodeInfo])
      })
    )
  }

  useEffect(() => {
    if (userType === Sites.consumer) {
      setTimeout(() => {
        pushTagManagerToDataLayer()
      }, 0)
    }
  }, [region, language])

  const activatePage = getById(pageContent, 'transactionSummaryPage')[language]

  return (
    <div className="flex flex-col max-w-4xl px-4 pb-12 m-auto space-y-4 justify-center items-center mt-16">

      <Heading1 className="font-bold text-center mb-5 hidden md:block">
        {getBySlug(activatePage?.shortTextFields, 'processing-loader-title')?.value}
      </Heading1>

      <Heading2 className="font-bold text-center mb-8 block md:hidden">
        {getBySlug(activatePage?.shortTextFields, 'processing-loader-title')?.value}
      </Heading2>

      <Body className="md:w-3/4 text-center">
        {selectSimType?.simType?.toUpperCase() === 'ESIM'
          ? getBySlug(activatePage?.shortTextFields, 'processing-loader-esim-message')?.value
          : getBySlug(activatePage?.shortTextFields, 'processing-loader-havesim-message')?.value}
      </Body>

      <div className="h-56 mt-12 flex items-center justify-center">
        <Image
          height={224}
          className="w-full h-full object-contain"
          // alt="Colorful Piñata"
          alt={getImgByTitle(activatePage, 'processing-loader-image')?.altText}
          src={getImgByTitle(activatePage, 'processing-loader-image')?.url}
        />
      </div>

      <p className="text-black text-sm mx-auto mb-6 !mt-4 font-bold" id="testid-processing-loader-bottom-message">
        {selectSimType?.simType?.toUpperCase() === 'ESIM'
          ? getBySlug(activatePage?.shortTextFields, 'processing-loader-esim-bottom-message')?.value
          : getBySlug(activatePage?.shortTextFields, 'processing-loader-havesim-bottom-message')?.value}
      </p>

    </div>
  )
}

export default ProcessLoader
